import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import classNames from 'classnames';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

export default class Rating extends Component {
    static propTypes = {
        iconCount: PropTypes.number.isRequired,
        fillCount: PropTypes.number,
        clickScore: PropTypes.func,
        iconStyle: PropTypes.object,
        iconType: PropTypes.string,
        children: PropTypes.element,
        tooltips: PropTypes.object
    };

    static defaultProps = {
        iconStyle: {
            color: 'gold'
        },
        tooltips: {},
        iconType: 'star'
    };

    constructor() {
        super();
        this.handleHoverIcons = this.handleHoverIcons.bind(this);
        this.handleHoverRating = this.handleHoverRating.bind(this);
        this.handleClickIcon = this.handleClickIcon.bind(this);
        this.displayIcons = this.displayIcons.bind(this);
        this.state = {
            isHovering: false,
            hoveringRating: 0
        };
    }

    handleHoverIcons(isHovering) {
        this.setState({isHovering});
    }

    handleHoverRating(rating) {
        this.setState({hoveringRating: rating});
    }

    handleClickIcon(e, score) {
        e.preventDefault();
        e.stopPropagation();

        const {clickScore} = this.props;

        clickScore(e, score);
    }

    displayIcons() {
        const {isHovering, hoveringRating} = this.state;
        const {iconCount, fillCount, iconStyle, iconType, tooltips} = this.props;

        return R.times(i => {
            const index = i + 1;

            const limit = isHovering ? hoveringRating : fillCount;
            const iconClassname = classNames(
                'fa fa-2x',
                `star-${index}`,
                index <= limit ? `fa-${iconType}` : `fa-${iconType}-o`
            );

            const tooltipText = R.prop(index, tooltips);

            const icon = (
                <a
                    className={`star-anchor-${index}`}
                    href="#"
                    key={index}
                    onClick={e => this.handleClickIcon(e, index)}
                    onMouseOver={() => {
                        this.handleHoverRating(index);
                    }}
                >
                    <i style={iconStyle} className={iconClassname} />
                </a>
            );

            if (tooltipText) {
                const tooltip = (
                    <Tooltip className="in" id={`tooltip-${index}`}>
                        <span>{tooltipText}</span>
                    </Tooltip>
                );

                return (
                    <span className="content-score-star" key={index}>
                        <OverlayTrigger
                            placement="top"
                            overlay={tooltip}
                            delay={0}
                            animation={false}
                        >
                            <span>{icon}</span>
                        </OverlayTrigger>
                    </span>
                );
            }

            return icon;
        }, iconCount);
    }

    render() {
        const icons = this.displayIcons();
        const {children} = this.props;

        return (
            <div
                className="star-rating"
                onMouseEnter={() => {
                    this.handleHoverIcons(true);
                }}
                onMouseLeave={() => {
                    this.handleHoverIcons(false);
                }}
            >
                {icons}
                {children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/rating.js